import React from 'react'

import {
  datesActivity,
  costActivity,
} from '../../../constants/activity-constants'

export const LOCALE = process.env.LOCALE

export const termsTest = [
  <>
    Todas las participantes de esta actividad deben estar registradas en
    www.nosotrasonline.com.do
  </>,
  <>
    Para jugar, las participantes deberán redimir {costActivity} puntos de su
    cuenta en www.nosotrasonline.com.do
  </>,
  <>
    Ganarán las chicas que más puntos acumulen en nuestro top. Si se encuentran
    en los puestos del 1 al 10, ganarán un espectacular kit de productos y
    merchandising Nosotras (Bolsa negra, kit manicure, set depilador y espejo,
    una bolsa caliente, protectores Nosotras diarios, panitos formula frescura
    extrema, toalla natural buenas noches, jabón íntimo Nosotras lavanda)
  </>,
  <>
    Todas las imágenes de los premios que están en el sitio, son para
    ejemplificarlos, son solo imágenes de referencia.
  </>,
  <>
    En caso de que la participante no pueda recibir el premio, no tendrá derecho
    a ningún otro producto diferente ni a ningún tipo de indemnización o
    compensación.
  </>,
  <>
    Los premios no son acumulables con otras promociones o actividades, no son
    intercambiables por dinero ni son canjeables por ningún otro concepto o
    producto identificado con la marca Nosotras ® o de Productos Familia S.A.
  </>,
  <>
    La marca Nosotras tiene el derecho de anular o descalificar cualquier
    material que considere que no cumple con las reglas del concurso. Así mismo,
    procederá con el material que no tenga relación con la mecánica de la
    actividad, que considere no apto o que atente contra los valores de la
    marca.
  </>,
  <>
    Con el hecho de participar en la actividad, las ganadoras aceptan y
    autorizan que su nombre y sus imágenes aparezcan en las publicaciones y
    demás material de divulgación con fines promocionales que los organizadores
    deseen hacer durante el concurso o una vez este finalice, sin que ello
    implique la obligación de remunerarlas o compensarlas.
  </>,
  <>
    El hecho de que la usuaria participe en la dinámica implica el conocimiento
    y la aceptación de las condiciones establecidas en reglamento, página web y
    correo electrónico.
  </>,
  <>
    La actividad estará al aire desde el {datesActivity.dateStartGame} hasta el{' '}
    {datesActivity.dateEndGame}.
  </>,
  <>
    Los nombres de las ganadoras se publicarán el {datesActivity.dateWinners}
  </>,
  <>
    Una vez finalizada la actividad, las ganadoras deberán entregar los empaques
    de las claves con las que participaron. La marca se pondrá en contacto con
    ellas para informarles sobre la dinámica de entrega. Después de que la marca
    se ponga en contacto con ellas, las usuarias tendrán un mes de plazo para
    enviar los empaques y reclamar los premios.
  </>,
  <>
    Concurso válido solo para usuarias de Colombia Recuerda actualizar tus
    datos. Es muy importante para que puedas participar.
  </>,
  <>
    En caso de tener dudas, o si quieres recibir mayor información, comunícate
    con nosotras por nuestras redes sociales o a
    https://www.nosotrasonline.do/contactanos/
  </>,
]
